import React, { useEffect } from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Toast from '../components/Toast';
import matchEntityLink from '../editor/utils/matchEntityLink';
import { UIActions } from '../ui/uiSlice';

const usePreferDesktopNotice = () => {
  const dispatch = useAppDispatch();

  const shouldPreferDesktop = useAppSelector(
    (state) => state.session.user.settings.preferDesktop,
  );

  useEffect(() => {
    // we only want to show this toast when directly navigating to a post,
    // therefore, we don't depend on react router's location
    const isPost = matchEntityLink(window.location.href)?.type === 'post';

    if (shouldPreferDesktop && isPost) {
      dispatch(
        UIActions.pushToast((toastProps: { onDismiss: () => void }) => (
          <Toast
            title="Open in desktop app?"
            message="You can view this post in Slab's native desktop app. Would you like to open this there?"
            onDismiss={toastProps.onDismiss}
            primaryText="Open desktop app"
            primaryTo={window.location.href.replace(/https?:\/\//, 'slab://')}
            onPrimaryClick={({ onDismiss }) => onDismiss()}
            secondaryTo="/settings"
            secondaryText="Settings"
            onSecondaryClick={({ onDismiss }) => onDismiss()}
          />
        )),
      );
    }
  }, [shouldPreferDesktop, dispatch]);
};

export default usePreferDesktopNotice;
